import { render, staticRenderFns } from "./FormulaTabs.vue?vue&type=template&id=0c34b207"
import script from "./FormulaTabs.vue?vue&type=script&lang=js"
export * from "./FormulaTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports